
<v-sheet class="basicConfigurator">
  <v-row class="header">
    <v-col>
      <h1 class="display-1">{{ title }}</h1>
    </v-col>
    <v-col>
      <v-row>
        <v-spacer/>
        <v-col cols="auto">
          <v-btn v-if="showBuyButton" class="buyButtonTop" color="primary" right @click="addToBasket">
            <v-icon>add_shopping_cart</v-icon>
            {{ buyButtonText }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <slot/>
  <v-row class="actionButtons" justify="center">
    <v-col cols="auto">
      <v-btn v-if="addedToBasket" class="actionButton" color="primary" @click="goToStep(3)">
        <v-icon>arrow_back</v-icon>
        {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
      </v-btn>
    </v-col>
    <v-col cols="auto">
      <v-btn v-if="showBuyButton" class="actionButton" color="primary" @click="addToBasket">
        <v-icon>add_shopping_cart</v-icon>
        {{ buyButtonText }}
      </v-btn>
    </v-col>
    <v-col cols="auto">
      <v-btn v-if="addedToBasket" class="actionButton" color="primary" @click="configureAgain">
        <v-icon>replay</v-icon>
        {{ $t("BUTTON_CONFIGURE_AGAIN") }}
      </v-btn>
    </v-col>
  </v-row>

</v-sheet>
